import React from "react";
import {
    Box,
    Checkbox,
    Divider,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { asDate } from "../../util/date";

const useStyles = makeStyles((theme) => ({
    itemContainer: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
    },
    label: {
        fontWeight: "bold",
        marginRight: theme.spacing(1),
        minWidth: "120px",
        display: "inline-block",
    },
    textField: {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
    },
}));

interface CopyGlobalFeeScheduleItemProps {
    item: any;
    isSelected: boolean;
    expirationDate: string;
    onToggle: () => void;
    onExpirationDateChange: (value: string) => void;
    isLast: boolean;
    expirationError?: string;
}

const CopyGlobalFeeScheduleItem: React.FC<CopyGlobalFeeScheduleItemProps> =
    React.memo(({ 
        item, 
        isSelected, 
        expirationDate, 
        onToggle, 
        onExpirationDateChange, 
        isLast,
        expirationError
    }) => {
        const classes = useStyles();

        return (
            <Box className={classes.itemContainer}>
                <Grid container spacing={2} alignItems="flex-start">
                    <Grid item>
                        <Checkbox
                            checked={isSelected}
                            onChange={onToggle}
                            color="primary"
                        />
                    </Grid>
                    <Grid item xs>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 600 }}
                        >
                             Effective: {asDate(item.effectiveDate)} –{" "}
                            {item.expirationDate
                                ? asDate(item.expirationDate)
                                : "Open"}
                        </Typography>

                        <Box display="flex" alignItems="center" mt={1}>
                            <Typography className={classes.label}>
                                Expiration Date:
                            </Typography>
                            <TextField
                                type="date"
                                size="small"
                                fullWidth
                                className={classes.textField}
                                value={expirationDate || ""}
                                onChange={(e) => onExpirationDateChange(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                error={!!expirationError}
                                helperText={expirationError}
                                required
                            />
                        </Box>

                       {item?.state && (
                            <Box display="flex" mt={0.5}>
                                <Typography className={classes.label}>
                                    State:
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ alignSelf: "center" }}
                                >
                                    {item.state}
                                </Typography>
                            </Box>
                        )}

                        {item?.gpci && (
                            <Box display="flex" mt={0.5}>
                                <Typography className={classes.label}>
                                    GPCI:
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ alignSelf: "center" }}
                                >
                                    {item.gpci}
                                </Typography>
                            </Box>
                        )}
                        {item?.locality && (
                            <Box display="flex" mt={0.5}>
                                <Typography className={classes.label}>
                                    Locality:
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ alignSelf: "center" }}
                                >
                                    {item.locality}
                                </Typography>
                            </Box>
                        )}

                        
                    </Grid>
                </Grid>
                {!isLast && <Divider sx={{ my: 2 }} />}
            </Box>
        );
    });

export default CopyGlobalFeeScheduleItem;
